import { modelCompetitorsMediaInvestmentOptions } from '@/dashboards/CompetitorsMediaInvestment/api';
import { getCategoriesFromCompetitorVariables } from '@/dashboards/CompetitorsMediaInvestment/helpers/getCategoriesFromCompetitorVariables';
import { getCompetitorSpendVariables } from '@/dashboards/CompetitorsMediaInvestment/helpers/getCompetitorSpendVariables';
import { parseCompetitorVariable } from '@/dashboards/CompetitorsMediaInvestment/helpers/parseCompetitorVariable';
import { FilterTypes } from '@/dashboards/CompetitorsMediaInvestment/types';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

export const useCompetitorsMediaInvestmentQuery = () => {
    const {
        dashboard: { dashboardVariables, id: dashboardId },
        isInputDuckDBAvailable,
    } = useDashboardGlobalContext();

    const competitorVariables: string[] = useMemo(
        () => getCompetitorSpendVariables(dashboardVariables),
        [dashboardVariables],
    );

    const categoryFilters = useMemo(() => {
        const categories =
            getCategoriesFromCompetitorVariables(competitorVariables);

        return categories.map((category) => ({
            name: category,
            label: category,
            selected: true,
        }));
    }, [competitorVariables]);

    const [selectedCategoryFilter, setSelectedCategoryFilter] =
        useState<FilterTypes[]>(categoryFilters);

    const selectedCategories = selectedCategoryFilter
        .filter((category) => category.selected)
        .map((category) => category.name);

    const filteredCompetitorVariables: string[] =
        selectedCategories.length === 0
            ? competitorVariables
            : competitorVariables.filter((variable) => {
                  const parsed = parseCompetitorVariable(variable);

                  if (!parsed) return false;

                  return selectedCategories.includes(parsed.channel);
              });

    const queryResult = useQuery({
        ...modelCompetitorsMediaInvestmentOptions({
            competitorVariables: filteredCompetitorVariables,
        }),
        queryKey: ['competitorsMediaInvestment', dashboardId, filteredCompetitorVariables],
        enabled: isInputDuckDBAvailable && filteredCompetitorVariables.length > 0,
        retry: false,
        gcTime: 0,
    });

    return {
        queryResult,
        selectedCategories,
        selectedCategoryFilter,
        setSelectedCategoryFilter,
    };
};
